// extracted by mini-css-extract-plugin
module.exports = {"widget":"widget__Ow60t","icon":"icon__1J_bb","title":"title__2J73s"};